import { render } from "./edit-test-series.vue?vue&type=template&id=6bb62602"
import script from "./edit-test-series.vue?vue&type=script&lang=js"
export * from "./edit-test-series.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__